import { Dropdown } from "@screencloud/screencloud-ui-components";
import { type WrappedComponentProps, injectIntl } from "react-intl";
import type { ShippingService } from "../../../hooks/usePixiWizardState";
import { Field, FieldRow } from "../styles";

export interface ShippingMethodFieldProps {
  /** The services the destination offers (from the backend rates). */
  services: ShippingService[];
  value?: ShippingService;
  onChange: (service: ShippingService) => void;
}

const SERVICE_LABELS: Record<
  ShippingService,
  { id: string; defaultMessage: string }
> = {
  standard: {
    id: "pixi_wizard.payment_shipping.shipping_method.standard",
    defaultMessage: "Standard Shipping",
  },
  express: {
    id: "pixi_wizard.payment_shipping.shipping_method.express",
    defaultMessage: "Express Shipping",
  },
};

/**
 * Shipping-service dropdown rendered as the last field of the Shipping
 * Information form, half-width to match the City field. Its options are the
 * services the destination actually offers (a standard-only country shows only
 * Standard); the choice is passed to the Checkout step, which resolves the
 * matching shipping rate.
 */
const ShippingMethodFieldBase = ({
  services,
  value,
  onChange,
  intl,
}: ShippingMethodFieldProps & WrappedComponentProps) => {
  const options = services.map((service) => ({
    key: service,
    value: service,
    text: intl.formatMessage(SERVICE_LABELS[service]),
  }));

  return (
    <FieldRow>
      <Field>
        <Dropdown
          fluid
          selection
          name="shippingService"
          options={options}
          value={value}
          onChange={(_event, data) => onChange(data.value as ShippingService)}
          data-testid="shipping-method-select"
        />
      </Field>
      <Field aria-hidden="true" />
    </FieldRow>
  );
};

export const ShippingMethodField = injectIntl(ShippingMethodFieldBase);
